import React from "react";
import trophy from '../../../../../styles/img/tropystar.png'

export const FinalMarksBox = (props) => {
    return (
        <>
            <div className="sb-final-marks-box">
                <div className={props.className}>
                    <div>
                        <h3>{props.title}</h3>
                        {
                            props.status === "passed" && <p>{props.marks}</p>
                        }
                    </div>

                    {
                        props.status === "passed" &&

                        <div className="sb-final-marks-box__trophy">
                            <img src={trophy} />
                        </div>
                    }
                </div>
            </div>
        </>
    )
}